var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"slider-wrapper",class:{ 'slider-blacked': _vm.blacked }},[_c('div',{ref:"durationLabel",staticClass:"durationLabel",style:({
      left: _vm.durationLabel.left,
      'margin-left': _vm.durationLabel.marginLeft,
      display: _vm.durationLabel.visible ? 'block' : 'none'
    })},[_vm._v(" "+_vm._s(_vm.durationLabel.text)+" ")]),_c('div',{ref:"slider",staticClass:"slider"},[_c('div',{ref:"markInLabel",staticClass:"markLabel markInLabel",style:({
        left: _vm.markInLabel.left,
        'margin-left': _vm.markInLabel.marginLeft,
        display: _vm.markInLabel.visible == true ? 'block' : 'none'
      })},[_vm._v(" "+_vm._s(_vm.markInLabel.text)+" ")]),_c('div',{ref:"markOutLabel",staticClass:"markLabel markOutLabel",style:({
        left: _vm.markOutLabel.left,
        'margin-left': _vm.markOutLabel.marginLeft,
        display: _vm.markOutLabel.visible == true ? 'block' : 'none'
      })},[_vm._v(" "+_vm._s(_vm.markOutLabel.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }